import {
  CLOSE_ALARMS,
  OPEN_ALARMS,
  SHARE_ALARMS,
  CANCEL_ALARMS,
  WS_DATA_ALARM,
  SET_ALARM_SOUND_ENABLED,
  SET_ALERT_SOUND_ENABLED,
  SET_ASS_REQ_SOUND_ENABLED,
  SET_RECORDING,
  GET_SAFETY_REGIONS,
  SET_DETAILED_ALARM,
  SAFETY_REGIONS_CHANGED, TOGGLE_ARC_ALARMS, SAVE_EXPIRATION_TIME,
  FETCH_V4_ALARMS, REFRESH_V4_ALARMS, V4_ALARMS_LOADED, V4_ALARMS_CLOSED, V4_ALARM_FORWARDING_CHANGED, V4_ALARM_CLOSED_LIVE, V4_ALARM_UPDATED_LIVE,
  FETCH_V4_CLOSED_ALARMS, REFRESH_V4_CLOSED_ALARMS, V4_CLOSED_ALARMS_LOADED, V4_CLOSED_ALARMS_RESET,
  SET_ALARM_LOCATION_VIEW, LATEST_ALARM_POSITION_LOADED, LATEST_ALARM_POSITION_FAILED
} from '../constants/alarm.constants';

export const updateAlarm = (alarm) => ({type: WS_DATA_ALARM, data: alarm });
export const shareAlarms = (alarms, recipients, language) => ({ type: SHARE_ALARMS, alarms, recipients, language});
export const closeAlarms = (alarms, blackbox) => ({ type: CLOSE_ALARMS, alarms, blackbox});
export const openAlarms = (alarms) => ({ type: OPEN_ALARMS, alarms});
export const cancelAlarms = (alarms) => ({ type: CANCEL_ALARMS, alarms });
export const setRecording = (recording) => ({ type: SET_RECORDING, recording });

export const setAlarmSoundEnabled = (isEnabled) => ({ type: SET_ALARM_SOUND_ENABLED, isEnabled });
export const setAlertSoundEnabled = (isEnabled) => ({ type: SET_ALERT_SOUND_ENABLED, isEnabled });
export const setAssistanceRequestSoundEnabled = (isEnabled) => ({ type: SET_ASS_REQ_SOUND_ENABLED, isEnabled });
export const getSafetyRegions = () => ({type: GET_SAFETY_REGIONS});
export const safetyRegionsChanged = data => ({type: SAFETY_REGIONS_CHANGED, data });
export const setDetailedAlarm = alarm => ({type: SET_DETAILED_ALARM, alarm});
export const toggleARCAlarms = () => ({type: TOGGLE_ARC_ALARMS});
export const saveAlertExpirationTime = expiration => ({type: SAVE_EXPIRATION_TIME, expiration});
export const fetchV4Alarms = () => ({type: FETCH_V4_ALARMS});
export const refreshV4Alarms = (accountId) => ({type: REFRESH_V4_ALARMS, accountId});
export const v4AlarmsLoaded = (alarms) => ({type: V4_ALARMS_LOADED, alarms});
// Optimistic close — moves alarms into the closed list without waiting on a
// refresh. Takes already-closed Alarm records.
export const v4AlarmsClosed = (alarms) => ({type: V4_ALARMS_CLOSED, alarms});
// Optimistic in-place update of a V4 alarm's forwarding status for instant ring
// feedback on `arc.alarm.*.forwarding.*` websocket events.
export const v4AlarmForwardingChanged = (alarmId, status) => ({type: V4_ALARM_FORWARDING_CHANGED, alarmId, status});
// `alarm.{id}.closed` on the websocket, applied ahead of the refetch.
export const v4AlarmClosedLive = (alarmId) => ({type: V4_ALARM_CLOSED_LIVE, alarmId});
// `alarm.{id}.updated` on the websocket: the open list refetches; a closed alarm needs the closed one.
export const v4AlarmUpdatedLive = (alarmId, accountId) => ({type: V4_ALARM_UPDATED_LIVE, alarmId, accountId});
// Closed V4 alarms come from a dedicated endpoint (`/v1/alarms/closed`); lazy-loaded on expand.
export const fetchV4ClosedAlarms = () => ({type: FETCH_V4_CLOSED_ALARMS});
// Silent refresh (after a close / `alarm.closed` event); only reloads an already-loaded list.
export const refreshV4ClosedAlarms = (accountId) => ({type: REFRESH_V4_CLOSED_ALARMS, accountId});
export const v4ClosedAlarmsLoaded = (alarms) => ({type: V4_CLOSED_ALARMS_LOADED, alarms});
// Clear to "never loaded" on account switch (avoids cross-account leak).
export const resetV4ClosedAlarms = () => ({type: V4_CLOSED_ALARMS_RESET});
export const setAlarmLocationView = (alarmId, view) => ({type: SET_ALARM_LOCATION_VIEW, alarmId, view});
export const latestAlarmPositionLoaded = (alarmId, position) => ({type: LATEST_ALARM_POSITION_LOADED, alarmId, position});
export const latestAlarmPositionFailed = (alarmId) => ({type: LATEST_ALARM_POSITION_FAILED, alarmId});